import React, { useEffect, useState } from "react";
import { getPlmProjectAllStatusApi, getPlmProjectAllTeamUserApi, getPlmProjectStandardsApi, createPlmProjectMilestoneApi } from '@/services'
import { useRequest } from "ahooks"
import { Modal, Select, Input, Button, DatePicker, Form, message, Spin } from "antd"
import type { DatePickerProps, FormProps } from 'antd';
import { documentUtil, toHsl, parseTime } from "@/utils"
import dayjs from "dayjs";

interface IProps{
    date?: string
    projectID?: string | number
    visible: boolean
    onClose: () => void
    onUpdate: ()=>void
}
const Index: React.FC<IProps> = (props) => {
    const [form] = Form.useForm()
    const { data: allStatus = [], loading: statusLoading, run: fetchAllStatus } = useRequest(getPlmProjectAllStatusApi, {
        manual: true,
        onSuccess: (data) => {
            if(data.length > 0) {
                form.setFieldsValue({ status: data[0].statusId })
            }
        }
    })
    const { data: allUser = [], loading: userLoading, run: fetchAllUsers } = useRequest(getPlmProjectAllTeamUserApi, {
        manual: true
    })
    const { data: allStandard = [], loading: standardLoading, run: fetchAllStandards } = useRequest(getPlmProjectStandardsApi, {
        manual: true,
        onSuccess: (data) => {

        }
    })
    const { loading: createLoading, runAsync: createPlmMilestone } = useRequest(createPlmProjectMilestoneApi, {
        manual: true
    })
    useEffect(() => {
        if (!props.visible) return
        form.setFieldsValue({ dueDate: props.date ? dayjs(props.date) : null })
        if (allStatus.length > 0) {
            form.setFieldsValue({ status: allStatus[0].statusId })
        }
        
    }, [props.visible])
    useEffect(() => {
        if(!props.projectID) return
        fetchAllStatus(props.projectID)
        fetchAllUsers(props.projectID)
        fetchAllStandards(props.projectID)
    }, [props.projectID])

    const onSubmit = async (vals: any) => {
        if (!props.projectID) {
            message.error("项目ID不可为空！")
            return
        }
        if(createLoading) return
        const values = {
            ...vals,
            'dueDate': vals['dueDate'].format('YYYY-MM-DD')
        }
        try {
            await createPlmMilestone(props.projectID, values)
            form.resetFields()
            props.onUpdate()
            props.onClose()
        } catch (error) {

        }
        
    }
    return (
        <Modal title="新建项目节点(PLM里程碑)" width="fit-content" destroyOnHidden maskClosable={false} open={props.visible} onCancel={props.onClose} footer={null}>
            <div className="min-w-[500px] pt-4">
                <Form
                    form={form}
                    name="basic"
                    initialValues={{ dueDate: props.date ? dayjs(props.date) : null  }}
                    onFinish={onSubmit}
                    autoComplete="off"
                >
                    <Form.Item<Request.PlmMilestone>
                        label="标题"
                        name="subject"
                        rules={[{ required: true, message: '请输入标题' }]}
                    >
                        <Input type="text" placeholder="输入标题" />
                    </Form.Item>
                    <div className="flex items-center gap-2 py-2 text-xs">
                        <Form.Item<Request.PlmMilestone>
                            label="状态"
                            name="status"
                            rules={[{ required: true, message: '请选择状态' }]}
                        >
                            <Select className="min-w-[100px]" options={allStatus?.map(v => ({ value: v.statusId, label: v.statusName }))} styles={{ popup: { root: { width: "fit-content", minWidth: 150 } } }} placeholder="选择里程碑状态" />
                        </Form.Item>
                        <Form.Item<Request.PlmMilestone>
                            label="日期"
                            name="dueDate"
                            rules={[{ required: true, message: '请选择日期' }]}
                        >
                            <DatePicker/>
                        </Form.Item>
                        <Form.Item<Request.PlmMilestone>
                            label="指定人"
                            name="assignedToID"
                        >
                            <Select className="min-w-[100px]"
                                options={allUser?.map(v => ({
                                    value: v.id,
                                    label: (
                                        <div className="flex items-center">
                                            <div className="w-[30px] h-[30px] leading-[30px] text-[12px] rounded-full text-white whitespace-nowrap scale-75 text-center"
                                                style={{ background: toHsl(v.name) }}>{v.name}</div>
                                            <span className="text-xs">{v.name}</span>
                                        </div>
                                    )

                                }))}
                                styles={{ popup: { root: { width: "fit-content", minWidth: 150 } } }}
                                placeholder="选择指定人"
                            />
                        </Form.Item>
                        <Form.Item<Request.PlmMilestone>
                            label="所属"
                            name="parentId"
                            rules={allStandard && allStandard.length > 0 ? [{ required: true, message: '选择所属标准任务' }] : undefined}
                        >
                            <Select className="min-w-[100px]"
                                options={allStandard?.map(v => ({
                                    value: v.id,
                                    label: v.name
                                }))}
                                styles={{ popup: { root: { width: "fit-content", minWidth: 150 } } }}
                                placeholder="选择所属标准任务"
                            />
                        </Form.Item>
                    </div>
                    <Form.Item<Request.PlmMilestone>
                        label="详情描述"
                        name="description"
                    >
                        <Input.TextArea autoSize={{ minRows: 10, maxRows: 20 }} placeholder="输入详情描述"></Input.TextArea>
                    </Form.Item>
                    <div className="mt-4 flex justify-end gap-4">
                        <Button danger onClick={props.onClose}>取消</Button>
                        <Button type="primary" htmlType="submit" disabled={createLoading}>确认</Button>
                    </div>
                </Form>
                
            </div>
        </Modal>
    )
}
export default Index